import { makeModuleI18nSelector } from "@client/content/selectors";
import { type ControlFormField, type FormFieldInfo } from "@client/controls/Form/component";
import TextInput from "@client/controls/Inputs/TextInput/component";
import { createSelector } from "reselect";
import { localStateFieldErrorSelector } from "../selectors";

export const makeFieldsSelector = () => {
  const i18nSelector = makeModuleI18nSelector();
  return createSelector([i18nSelector, localStateFieldErrorSelector], (i18n, fieldError) => {
    const fields: FormFieldInfo[] = [
      {
        Component: TextInput,
        defaultValue: "",
        label: i18n.password,
        name: "password",
        isRequired: true,
        componentOpts: { type: "password" }
      },
      {
        Component: TextInput,
        defaultValue: "",
        label: i18n.confirmPassword,
        name: "confirmPassword",
        isRequired: true,
        componentOpts: { type: "password" }
      }
    ];

    if (fieldError) {
      const field = fields.find((f) => "name" in f && f.name === fieldError.field) as ControlFormField;
      field && (field.error = fieldError.error);
    }

    return fields;
  });
};
